export const Wishlist = ()=>{
    return(
        <div><h1>Hello</h1></div>
    )
}